import React from "react";
import { FaPlay } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";

// Blog data
const blogData = [
  {
    id: 1,
    type: "featured", // large blog
    title: "Construction of Link new high tech plant in washingtons",
    author: "Nayeem",
    date: "Feb 8, 2024",
    description:
      "Industry's standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and...",
    tag: "Company",
    img: "assets/images/blog/blog-thumb-01.png",
  },
  {
    id: 2,
    type: "grid", // small blog
    title: "Building resilient supply chains for",
    author: "Nayeem",
    date: "Feb 8, 2024",
    description: "Industry's standard dummy text ever....",
    tag: "Oil Factory",
    img: "assets/images/blog/blog-thumb-02.png",
  },
  {
    id: 3,
    type: "grid", // small blog
    title: "Factories technologies in interactive and",
    author: "Nayeem",
    date: "Feb 8, 2024",
    description: "Industry's standard dummy text ever....",
    tag: "Manufacture",
    img: "assets/images/blog/blog-thumb-03.png",
  },
];

const Blog = () => {
  // Split featured and grid posts
  const featuredPost = blogData.find((b) => b.type === "featured");
  const gridPosts = blogData.filter((b) => b.type === "grid");

  return (
    <section className="rs-blog-area section-space rs-blog-one">
      <div className="container">
        {/* Section Title */}
        <div className="row g-5 section-title-space align-items-center">
          <div className="col-xl-7 col-lg-7">
            <div className="rs-section-title-wrapper">
              <span className="rs-section-subtitle has-theme-orange justify-content-start">
                <FaPlay color="#EA5501" size={12} />
                Update
              </span>
              <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                Articles & blog posts with useful information
              </h2>
            </div>
          </div>
          <div className="col-xl-5 col-lg-5">
            <div className="rs-blog-btn">
              <Link
                className="rs-btn has-theme-orange has-icon has-bg"
                to="/blog"
              >
                View All Post
                <span className="icon-box">
                  <FiArrowRight className="icon-first" />
                  <FiArrowRight className="icon-second" />
                </span>
              </Link>
            </div>
          </div>
        </div>

        {/* Blog Posts */}
        <div className="row g-5">
          {/* Featured Post */}
          {featuredPost && (
            <div className="col-xl-6 col-lg-6">
              <div
                className="rs-blog-item has-thumb-height wow fadeInLeft"
                data-wow-delay=".3s"
                data-wow-duration="1s"
              >
                <div
                  className="has-bg has-clip-path rs-blog-bg-thumb"
                  style={{
                    backgroundImage: `url(${featuredPost.img})`,
                  }}
                ></div>
                <div className="rs-blog-content has-position">
                  <div className="rs-blog-meta">
                    <div className="rs-blog-meta-item has-white">
                      <span>
                        By
                        <Link className="rs-blog-meta-author" to="#">
                          {" "}
                          {featuredPost.author}
                        </Link>
                      </span>
                    </div>
                    <div className="rs-blog-meta-item has-white">
                      <span>{featuredPost.date}</span>
                    </div>
                  </div>
                  <h3 className="rs-blog-title has-white has-big underline">
                    <Link to="/blog-details">{featuredPost.title}</Link>
                  </h3>
                  <p className="rs-blog-description has-white">
                    {featuredPost.description}
                  </p>
                  <div className="rs-blog-tag has-white">
                    <Link to="/blog-details">{featuredPost.tag}</Link>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grid Posts */}
          <div className="col-xl-6 col-lg-6">
            <div
              className="row g-5 wow fadeInRight"
              data-wow-delay=".3s"
              data-wow-duration="1s"
            >
              {gridPosts.map((post) => (
                <div className="col-12" key={post.id}>
                  <div className="rs-blog-item has-grid">
                    <div className="rs-blog-content has-padding order-1 order-sm-0">
                      <div className="rs-blog-meta">
                        <div className="rs-blog-meta-item">
                          <span>
                            By
                            <Link className="rs-blog-meta-author" to="#">
                              {" "}
                              {post.author}
                            </Link>
                          </span>
                        </div>
                        <div className="rs-blog-meta-item">
                          <span>{post.date}</span>
                        </div>
                      </div>
                      <h5 className="rs-blog-title underline has-black">
                        <Link to="/blog-details">{post.title}</Link>
                      </h5>
                      <p className="rs-blog-description">{post.description}</p>
                      <div className="rs-blog-tag">
                        <Link to="/blog-details">{post.tag}</Link>
                      </div>
                    </div>
                    <div className="rs-blog-thumb has-clip-path order-0 order-sm-1">
                      <Link to="/blog-details">
                        <img src={post.img} alt="imagee" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
